var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('invoices-table',{attrs:{"invoices":_vm.invoices,"top-paging":false,"show-property":false,"title-bar":"","actionable":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }